<template>
  <div class="nav-container">
    <div class="logo-header">
      <a href="./search-grants">
        <div class="logo" />
      </a>
    </div>

    <div v-bind:class="{ show: isExpanded }">
      <div class="menu-buttons">
        <Slide right class="burger-menu">
          <router-link :to="{ name: 'SearchGrants' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Subsidies zoeken"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link :to="{ name: 'News' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Nieuws zoeken"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link :to="{ name: 'HomePage' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Actueel"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link
            :to="{ name: 'UserProfile', params: { tab: 'myBasicDetails' } }"
            v-if="isLoggedIn"
          >
            <q-btn
              outline
              color="primary"
              label="Profile"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>
        </Slide>

        <div class="largescreen-buttons">
          <div class="all-menu-buttons">
            <div class="leftmenu-buttons">
              <router-link :to="{ name: 'SearchGrants' }" class="navmenu-link">
                <q-btn
                  flat
                  color="white"
                  label="Subsidies zoeken"
                  no-caps
                  v-if="isLoggedIn"
                  class="navmenu-link q-ml-sm bold-text"
                >
                </q-btn>
              </router-link>
              <router-link :to="{ name: 'News' }" class="navmenu-link">
                <q-btn
                  class="navmenu-link q-ml-sm bold-text"
                  flat
                  color="white"
                  no-caps
                  label="Nieuws zoeken"
                  v-if="isLoggedIn"
                >
                  <q-badge
                    v-if="displayNumberOfNewsResults"
                    class="results-badge"
                    :label="resultsCount"
                    >{{ resultCount }}</q-badge
                  >
                </q-btn>
              </router-link>
              <router-link :to="{ name: 'HomePage' }" class="navmenu-link">
                <q-btn
                  flat
                  color="white"
                  label="Actueel"
                  no-caps
                  v-if="isLoggedIn"
                  class="navmenu-link q-ml-sm bold-text"
                >
                </q-btn>
              </router-link>
            </div>
            <div class="right-menu-buttons">
              <q-btn
                flat
                color="white"
                class="q-mr-md"
                @click="toggleTheme()"
                v-if="isLoggedIn"
              >
                <q-tooltip
                  v-if="isContrastTheme != 'false' && isContrastTheme != false"
                >
                  Hoog contrast uit
                </q-tooltip>
                <q-tooltip v-else>Hoog contrast aan </q-tooltip>

                <i class="las la-2x la-adjust action-icon"> </i>
              </q-btn>

              <q-btn-dropdown
                flat
                color="white"
                v-if="isLoggedIn"
                icon="account_circle"
                class="navmenu-link"
                id="v-step-13"
              >
                <q-list>
                  <router-link
                    :to="{
                      name: 'UserProfile',
                      params: { tab: 'myBasicDetails' },
                    }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section> Mijn gegevens </q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    v-if="isVind"
                    :to="{ name: 'UserProfile', params: { tab: 'newsletter' } }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section> Profiel en Nieuwsbrief </q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    v-if="isVind"
                    :to="{ name: 'UserProfile', params: { tab: 'savedItems' } }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section> Opgeslagen items </q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    v-if="isVind"
                    :to="{
                      name: 'UserProfile',
                      params: { tab: 'hiddenSchemes' },
                    }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section> Verborgen items </q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    v-if="showAdminPanel && isVind"
                    :to="{
                      name: 'UserProfile',
                      params: { tab: 'userManagement' },
                    }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section>
                        Accountbeheer
                      </q-item-section>
                    </q-item>
                  </router-link>

                  <router-link
                    flat
                    color="white"
                    :to="{ name: 'Login' }"
                    class="navmenu-link"
                    style="text-decoration: none"
                  >
                    <q-item clickable v-close-popup>
                      <q-item-section @click="logout">
                        Uitloggen
                      </q-item-section>
                    </q-item>
                  </router-link>
                </q-list>
              </q-btn-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/index.js';
import { Slide } from 'vue3-burger-menu';
import { computed, ref } from 'vue';
export default {
  name: 'NavMenu',
  components: {
    Slide,
  },
  setup() {
    const logout = () => {
      store.dispatch('auth/logout');
      this.$router.push('/login');
    };

    const collapse = () => {
      this.isExpanded = false;
    };

    const toggle = () => {
      this.isExpanded = !this.isExpanded;
    };

    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    const showAdminPanel = computed({
      get: () => store.state.auth.showAdminPanel,
    });

    const isExpanded = ref(false);

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    const resultCount = computed({
      get: () => store.state.newsSearch.resultsCount,
    });

    const displayNumberOfNewsResults = computed({
      get: () => store.state.advancedSearch.displayNumberOfNewsResults,
    });

    const setThemeToContrast = () => {
      store.commit('user/setIsSelectedThemeContrast', true);
      localStorage.setItem('themeContrast', true);
    };

    const setNormalTheme = () => {
      store.commit('user/setIsSelectedThemeContrast', false);
      localStorage.setItem('themeContrast', false);
    };

    const toggleTheme = () => {
      if (isContrastTheme.value == false || isContrastTheme.value == 'false') {
        store.commit('user/setIsSelectedThemeContrast', true);
        localStorage.setItem('themeContrast', true);
      } else {
        store.commit('user/setIsSelectedThemeContrast', false);
        localStorage.setItem('themeContrast', false);
      }
    };

    const isContrastTheme = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });

    return {
      toggleTheme,
      isContrastTheme,
      setNormalTheme,
      setThemeToContrast,
      displayNumberOfNewsResults,
      resultCount,
      logout,
      isLoggedIn,
      collapse,
      toggle,
      isExpanded,
      showAdminPanel,
      isVind,
    };
  },
};
</script>
